import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';
import {ConfigService} from '../utils/config.service';
import {switchMap} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {Observable} from 'rxjs';
import {LocalStorageService} from '../utils/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorageService: LocalStorageService,
    public configService: ConfigService,
  ) {
  }

  get(service: string, url: string, params: any = {}, auth = true, real = false, options: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
  } = {}): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);
    return this.localStorageService.getItem(
      real ?
        ConfigService.localStorage.token_real :
        ConfigService.localStorage.token)
      .pipe(
        switchMap(token => {
          if (!token) {
            return new BehaviorSubject<boolean>(false);
          }

          const $params = new HttpParams({
            fromObject: params,
          });
          // for (const param in params) {
          //   if (params.hasOwnProperty(param) && !!params[param]) {
          //     $params = $params.set(param, params[param]);
          //   }
          // }

          // @ts-ignore
          return this.http.get<any>(apiUrl, {
            headers: new HttpHeaders({
              'Authorization': 'Bearer ' + token,
            }),
            params: $params,
            ...options,
          });
        }),
      );
  }

  post(service: string, url: string, body: any = {}, auth = true, real = false, options: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
  } = {}): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.localStorageService.getItem(ConfigService.localStorage.token)
      .pipe(
        switchMap(token => {
          if (!token) {
            return new BehaviorSubject<boolean>(false);
          }

          // @ts-ignore
          return this.http.post<any>(apiUrl, body, {
            headers: new HttpHeaders({
              'Authorization': 'Bearer ' + token,
            }),
            ...options,
          });
        }),
      );
  }

  patch(service: string, url: string, body: any = {}, auth = true): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.localStorageService.getItem(ConfigService.localStorage.token)
      .pipe(
        switchMap(token => {
          if (!token) {
            return new BehaviorSubject<boolean>(false);
          }

          return this.http.patch<any>(apiUrl, body, {
            headers: new HttpHeaders({
              'Authorization': 'Bearer ' + token,
            }),
          });
        }),
      );
  }

  put(service: string, url: string, body: any = {}, auth = true): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.localStorageService.getItem(ConfigService.localStorage.token)
      .pipe(
        switchMap(token => {
          if (!token) {
            return new BehaviorSubject<boolean>(false);
          }

          return this.http.put<any>(apiUrl, body, {
            headers: new HttpHeaders({
              'Authorization': 'Bearer ' + token,
            }),
          });
        }),
      );
  }

  delete(service: string, url: string) {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.localStorageService.getItem(ConfigService.localStorage.token)
      .pipe(
        switchMap(token => {
          if (!token) {
            return new BehaviorSubject<boolean>(false);
          }

          return this.http.delete<any>(apiUrl, {
            headers: new HttpHeaders({
              'Authorization': 'Bearer ' + token,
            }),
          });
        }),
      );
  }
}
